/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByCustomColumnKind = (typeof GroupByCustomColumnKind)[keyof typeof GroupByCustomColumnKind];

export const GroupByCustomColumnKind = {
  custom_column: 'custom_column',
} as const;
